interface ContactStripProps {
  email: string;
  title?: string;
  description?: string;
}

export default function ContactStrip({
  email,
  title = 'Contact',
  description = 'Questions about a division, a project, or a quote? Reach out and we will respond during business hours.',
}: ContactStripProps) {
  return (
    <section id="contact" className="bg-primary-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            <div>
              <p className="text-accent-400 text-sm font-semibold tracking-widest uppercase mb-3">
                Get in Touch
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-6">
                {title}
              </h2>
              <p className="text-background-300 text-base md:text-lg leading-relaxed max-w-xl">
                {description}
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-5">
              <a
                href={`mailto:${email}`}
                className="bg-background-50/5 border border-background-50/10 rounded-xl p-5 hover:bg-background-50/10 transition-colors"
              >
                <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center mb-4">
                  <i className="ri-mail-line text-accent-300 text-lg" />
                </div>
                <p className="text-background-400 text-xs uppercase tracking-wider font-semibold mb-1">
                  Email
                </p>
                <p className="text-background-50 text-sm font-medium break-all">{email}</p>
              </a>

              <a
                href="tel:+18044647418"
                className="bg-background-50/5 border border-background-50/10 rounded-xl p-5 hover:bg-background-50/10 transition-colors"
              >
                <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center mb-4">
                  <i className="ri-phone-line text-accent-300 text-lg" />
                </div>
                <p className="text-background-400 text-xs uppercase tracking-wider font-semibold mb-1">
                  Phone
                </p>
                <p className="text-background-50 text-sm font-medium">(804) 464-7418</p>
              </a>

              <div className="bg-background-50/5 border border-background-50/10 rounded-xl p-5">
                <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center mb-4">
                  <i className="ri-map-pin-line text-accent-300 text-lg" />
                </div>
                <p className="text-background-400 text-xs uppercase tracking-wider font-semibold mb-1">
                  Mailing Address
                </p>
                <p className="text-background-50 text-sm font-medium">
                  PO Box 432, Midlothian, VA 23113
                </p>
              </div>

              <div className="bg-background-50/5 border border-background-50/10 rounded-xl p-5">
                <div className="w-10 h-10 rounded-lg bg-accent-500/20 flex items-center justify-center mb-4">
                  <i className="ri-time-line text-accent-300 text-lg" />
                </div>
                <p className="text-background-400 text-xs uppercase tracking-wider font-semibold mb-1">
                  Hours
                </p>
                <p className="text-background-50 text-sm font-medium">
                  Mon&ndash;Fri, 9:00 a.m.&ndash;5:00 p.m. Eastern
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}